class AnimationManager {
  private callbacks = new Set<() => void>()
  private rafId: number | null = null

  register(callback: () => void): () => void {
    this.callbacks.add(callback)
    this.start()
    return () => {
      this.unregister(callback)
    }
  }

  private unregister(callback: () => void): void {
    this.callbacks.delete(callback)
    if (this.callbacks.size === 0) {
      this.stop()
    }
  }

  private start(): void {
    if (this.rafId !== null) return

    const animate = () => {
      this.callbacks.forEach(cb => cb())
      this.rafId = requestAnimationFrame(animate)
    }

    this.rafId = requestAnimationFrame(animate)
  }

  private stop(): void {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId)
      this.rafId = null
    }
  }
}

export const animationManager = new AnimationManager()

